export function createTexture(gl: WebGL2RenderingContext): WebGLTexture {
  const texture = gl.createTexture();

  if (texture == null) {
    throw Error("texture allocation failed");
  }

  return texture;
}
